import { useMutation } from "@tanstack/react-query";

import { PageState } from "api/generated/model";
import { postShareableLinks } from "api/generated/shareable-links/shareable-links";

import { SHAREABLE_LINK_ID_QUERY_PARAM } from "../consts";

interface PageStateMutationVars {
    data: PageState;
    preservedSearchParams: string[];
}
export function usePageStateMutation() {
    return useMutation({
        mutationFn: async (vars: PageStateMutationVars) => {
            const response = await postShareableLinks(vars.data);
            const shareableLinkView = response.data;
            const linkUrl = buildLinkToCurrentPage(
                shareableLinkView.id,
                vars.preservedSearchParams
            );

            return linkUrl;
        },
    });
}

function buildLinkToCurrentPage(
    shareableLinkId: string,
    preservedSearchParams: Array<string>
): string {
    const url = new URL(location.toString());
    const currentSearchParams = url.searchParams;

    const newSearchParams = new URLSearchParams();
    newSearchParams.set(SHAREABLE_LINK_ID_QUERY_PARAM, shareableLinkId);
    preservedSearchParams.forEach((paramName) => {
        const paramValue = currentSearchParams.get(paramName);
        if (paramValue !== null && paramValue !== undefined) {
            newSearchParams.set(paramName, paramValue);
        }
    });

    url.search = newSearchParams.toString();
    return url.toString();
}
